import React from 'react';
import SharedReviewPage from '../SharedReviewPage';
import PrivacyPolicy from '../PrivacyPolicy';
import TermsOfService from '../TermsOfService';
import SharedRoutePage from '../seo/SharedRoutePage';
import FricampingLandingPage from '../seo/FricampingLandingPage';
import { InitialRouteState } from '../../services/appRouteState';

type AppEntryViewProps = {
  routeState: InitialRouteState;
};

const AppEntryView: React.FC<AppEntryViewProps> = ({ routeState }) => {
  if (routeState.isPrivacyPath) {
    return <PrivacyPolicy />;
  }

  if (routeState.isTermsPath) {
    return <TermsOfService />;
  }

  if (routeState.resolvedReviewId) {
    return <SharedReviewPage reviewId={decodeURIComponent(routeState.resolvedReviewId)} />;
  }

  if (routeState.resolvedSharedSpotId) {
    return <SharedReviewPage reviewId="" spotId={decodeURIComponent(routeState.resolvedSharedSpotId)} />;
  }

  if (routeState.resolvedSharedRouteId) {
    return <SharedRoutePage routeId={decodeURIComponent(routeState.resolvedSharedRouteId)} />;
  }

  if (routeState.resolvedSeoCounty) {
    return (
      <FricampingLandingPage
        countySlug={decodeURIComponent(routeState.resolvedSeoCounty)}
        municipalitySlug={routeState.resolvedSeoMunicipality ? decodeURIComponent(routeState.resolvedSeoMunicipality) : undefined}
      />
    );
  }

  return null;
};

export default AppEntryView;
